import { isApiError, jsonInit } from '@shigo-ui/api-client';
import { z } from 'zod';
import { createShigoApiClient, type ShigoApiConfig } from '../../../../../../lib/shigo-api-client';
import { dashboardT } from '../../../../../../lib/messages';
import { journeyResponseSchema, type JourneyRequest } from './journeyFlowModel';

export function createJourneyClient(
  config: ShigoApiConfig,
  accessToken: string,
  fetcher?: typeof fetch,
) {
  const api = createShigoApiClient(config, accessToken, fetcher);
  return {
    run: (request: JourneyRequest) =>
      api.request({
        path: '/api/report/ch/dpi-journey/v2',
        schema: journeyResponseSchema,
        init: jsonInit('POST', request),
      }),
  };
}
const reportingErrorSchema = z.object({ error: z.object({ messages: z.array(z.string()) }) });
export function journeyErrorMessage(error: unknown): string {
  if (isApiError(error) && error.status === 400) {
    const parsed = reportingErrorSchema.safeParse(error.body);
    if (parsed.success && parsed.data.error.messages.length)
      return parsed.data.error.messages.join(' ');
  }
  return dashboardT('journey.error');
}
